import { action } from "satcheljs";

const toggleHideConflictManagement = action(
    "toggleHideConflictManagement",
    () => ({})
);

export default toggleHideConflictManagement;